// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Media} from "@models";
import {SimUtilityExtendedService} from "@services";
import {Translations} from "@translations";

export interface DialogData_VideoDialogInput extends MatDialogDataBaseInput {
	media?: Media;
	mediaUrl?: string;
	mediaName?: string;
}

export interface DialogData_VideoDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-video-dialog",
	templateUrl: "./video-dialog.component.html",
	styleUrls: ["./video-dialog.component.scss"],
	standalone: false,
})
export class VideoDialogComponent extends BasicMaterialDialog<
	VideoDialogComponent,
	DialogData_VideoDialogInput,
	DialogData_VideoDialogOutput
> {
	T = Translations;
	videoError: boolean;

	constructor(
		public simUtilityService: SimUtilityExtendedService,
		_injector: Injector,
	) {
		super(_injector);
	}

	ngOnInit(): void {}
}
